module.exports = __webpack_public_path__ + "static/media/cestovat-chladny-dno-jednoduchost-2868847.a67df138.jpg";